import { ISearchResults } from "@app/redux/reducers/search";
import { SearchItemsModules } from "./search-results.module";

/**
 * Which sections the search page shows. Shared by the component, its no-results state and the
 * page's structured data, so the graph can never describe a section the page does not render.
 *
 * With `showWhenNoData` an enabled section also counts as shown when nothing at all was found:
 * that is when the page falls back to its popular items.
 */
export const getModulesToShow = (
  modules?: SearchItemsModules[],
  searchResults?: ISearchResults,
  showWhenNoData?: boolean
) => {
  const noData =
    (!searchResults?.merchants?.data || searchResults.merchants.data.length === 0) &&
    (!searchResults?.products?.data || searchResults.products.data.length === 0) &&
    (!searchResults?.deals?.data || searchResults.deals.data.length === 0) &&
    (!searchResults?.pages?.data || searchResults.pages.data.length === 0);

  return {
    showMerchants:
      modules?.includes("merchants") &&
      ((searchResults?.merchants?.data && searchResults.merchants.data.length > 0) || (showWhenNoData && noData)),
    showProducts:
      modules?.includes("products") &&
      ((searchResults?.products?.data && searchResults.products.data.length > 0) || (showWhenNoData && noData)),
    showDeals:
      modules?.includes("deals") &&
      ((searchResults?.deals?.data && searchResults.deals.data.length > 0) || (showWhenNoData && noData)),
    showPages:
      modules?.includes("pages") &&
      ((searchResults?.pages?.data && searchResults.pages.data.length > 0) || (showWhenNoData && noData))
  };
};
